import React, { useState, useEffect } from "react";
import { Box, Container, makeStyles, Typography } from "@material-ui/core";
import Page from "src/components/Page";
import Form from "./Form";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import {
  apiEndpoints,
  apiPutRequest,
  apiGetByIdRequest,
} from "src/utils/api/api";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import KmPageTitle from "src/components/layout/KmPageTitle";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  title: {
    marginLeft: theme.spacing(3),
  },
}));

const AttendancePreviewForm = ({
  enableGlobalLoader,
  disableGlobalLoader,
  displaySnackbar,
  setLogoutUser,
  ...rest
}) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { entryId } = useParams();
  const [committeeAttendance, setCommitteeAttendance] = useState();
  const [reloadCounter, setReloadCounter] = useState(0);

  let pageTitle = "Szczegóły potwierdzeń uczestnictwa";

  useEffect(() => {
    enableGlobalLoader();
    apiGetByIdRequest(
      apiEndpoints.getCommitteeAttendancePreview.path,
      entryId,
      true
    )
      .then((data) => {
        disableGlobalLoader();
        setCommitteeAttendance(data);
      })
      .catch((error) => {
        disableGlobalLoader();
      });
    return () => {};
  }, [reloadCounter]);

  const cancelAttendanceHandler = (canceledAttendance) => {
    enableGlobalLoader();

    if (canceledAttendance) {
      apiPutRequest(
        apiEndpoints.setCommitteeAttendanceConfirmationForUser.path,
        {
          structNodeId: entryId,
          userId: canceledAttendance.userId,
          action: "cancel",
        },
        true
      )
        .then((data) => {
          disableGlobalLoader();
          setReloadCounter(reloadCounter + 1);
        })
        .catch((error) => {
          disableGlobalLoader();
          if (error.response && error.response.status === 401) {
            setLogoutUser();
          }
        });
    }
  };

  return (
    <Page className={classes.root} title={pageTitle}>
      <KmPageTitle>{pageTitle}</KmPageTitle>

      <Container maxWidth={false}>
        <Box mt={3}>
          <Form
            committeeAttendance={committeeAttendance}
            entryId={entryId}
            onCancelAttendance={cancelAttendanceHandler}
          />
        </Box>
      </Container>
    </Page>
  );
};

const mapDispatchToProps = (dispatch) => ({
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
  displaySnackbar: (snackBarParameters) =>
    dispatch(actions.displaySnackbar(snackBarParameters)),
  setLogoutUser: () => dispatch(actions.setLogoutUser())
});

export default connect(null, mapDispatchToProps)(AttendancePreviewForm);
